module.exports = require('./DepNewBankCharterFilingView');
